module.exports = require('./DepNewBankCharterFilingView');
